var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoReglage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 14.5,
    viewBox: "0 0 15.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3249",
    "data-name": "Groupe 3249",
    transform: "translate(774.348 6007.803)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_239",
    "data-name": "Ligne 239",
    y2: 2,
    transform: "translate(-771.598 -5996.053)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_240",
    "data-name": "Ligne 240",
    y2: 7,
    transform: "translate(-771.598 -6007.053)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_241",
    "data-name": "Ligne 241",
    y2: 8.5,
    transform: "translate(-766.6 -6002.553)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_242",
    "data-name": "Ligne 242",
    y2: 2,
    transform: "translate(-761.598 -5996.053)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_243",
    "data-name": "Ligne 243",
    y2: 7,
    transform: "translate(-761.598 -6007.053)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-768.598 -6007.053)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-773.598 -6000.053)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-763.598 -6000.053)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoReglage);
export default __webpack_public_path__ + "static/media/picto-reglage.c0a8a6a9975ff3d0ffbd0eddac7425c2.svg";
export { ForwardRef as ReactComponent };